export const EGenderType = {
  Woman: 0,

  Man: 1,

  Children: 2,

  WomanAndMan: 3,

  WomanAndChildren: 4,

  ManAndChildren: 5,

  All: 6,
} as const

export type EGenderType = (typeof EGenderType)[keyof typeof EGenderType]
